import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Footer.module.css';

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <div className={styles.brand}>
          <span className={styles.brandIcon}>🔍</span>
          <span className={styles.brandName}>HARScope</span>
          <span className={styles.tagline}>— Privacy-first HAR analyzer for pentesters</span>
        </div>
        <div className={styles.links}>
          <Link to="/" className={styles.link}>Viewer</Link>
          <Link to="/about" className={styles.link}>About</Link>
          <Link to="/contact" className={styles.link}>Contact</Link>
          <a href="/sitemap.xml" className={styles.link} target="_blank" rel="noreferrer">Sitemap</a>
          <a href="/robots.txt" className={styles.link} target="_blank" rel="noreferrer">robots.txt</a>
        </div>
        <div className={styles.copy}>
          © {new Date().getFullYear()} HARScope · Zero uploads · Zero tracking · Free forever
        </div>
      </div>
    </footer>
  );
}
